// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventTitle_wrapper__m_A6z"};